import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimRadioGroup } from '../fields';

export const Box06_PatientRelationship: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">6. PATIENT RELATIONSHIP TO INSURED</Typography>
      <Controller
        name="patientRelationship"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimRadioGroup
            field={field}
            fieldState={fieldState}
            options={[
              { value: 'self', label: 'Self' },
              { value: 'spouse', label: 'Spouse' },
              { value: 'child', label: 'Child' },
              { value: 'other', label: 'Other' },
            ]}
            row
            sx={{
              flexWrap: 'wrap',
              gap: 0.5,
              '& .MuiFormControlLabel-root': {
                marginRight: 2,
                marginBottom: 0.5,
              },
            }}
          />
        )}
      />
    </>
  );
};